import { Loader } from 'semantic-ui-react';

const LoadingComponent = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: '3.5em', // account for fixed top nav height
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        pointerEvents: 'none', // don't block interactions behind when needed
      }}
    >
      <Loader active size="large" inline="centered" />
    </div>
  );
};

export default LoadingComponent;
